<template>
    <!-- <div> -->
    <scrollactive
        class="navbar sticky-top navbar-expand-lg navbar-dark px-4 py-3"
        style="background-color: #121212"
        id="navbar"
        v-on:itemchanged="onItemChanged"
        :offset="72"
        :duration="800"
        bezier-easing-value=".5,0,.35,1"
    >
        <a
            class="navbar-brand scrollactive-item"
            href="#home"
            @click="scrollUp"
        >
            <!-- <img src="../assets/stanford.png" width="40" height="40" class="d-inline-block align-middle" alt="" /> -->
            The Wong Lab
        </a>
        <button
            class="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
        >
            <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav mr-auto">
                <li class="nav-item">
                    <a
                        class="nav-link scrollactive-item home-page link"
                        href="#home"
                    >
                        <span> Home </span>
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link scrollactive-item link" href="#about">
                        <span> About </span>
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link scrollactive-item link" href="#research">
                        <span> Research </span>
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link scrollactive-item link" href="#team">
                        <span> Team </span>
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link scrollactive-item link" href="#contact">
                        <span>Contact</span>
                    </a>
                </li>
                <li class="nav-item dropdown link">
                    <a
                        class="nav-link dropdown-toggle"
                        href="#"
                        id="navbarDropdown"
                        role="button"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                    >
                        <span> Extra </span>
                    </a>
                    <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                        <a
                            class="dropdown-item link"
                            href="http://med.stanford.edu/neurosurgery/research/wong/gifts.html"
                            target="_blank"
                        >
                            <span>Make a Donation</span>
                        </a>
                        <a
                            class="dropdown-item link"
                            href="http://med.stanford.edu/neurosurgery/research/wong/publications.html"
                            target="_blank"
                        >
                            <span> Full List of Publications </span>
                        </a>
                        <div class="dropdown-divider"></div>
                        <a
                            class="dropdown-item link"
                            href="https://www.stanford.edu/"
                            target="_blank"
                        >
                            <span> Stanford University </span>
                        </a>
                    </div>
                </li>
            </ul>

            <form class="form-inline my-2 my-lg-0" @submit.prevent="search">
                <input
                    class="form-control mr-sm-2"
                    type="search"
                    placeholder="Search"
                    aria-label="Search"
                    v-model="searchQuery"
                />
                <button
                    class="btn btn-outline-danger my-2 my-sm-0"
                    type="submit"
                >
                    Search
                </button>
            </form>
        </div>
    </scrollactive>
    <!-- </div> -->
</template>

<script>
export default {
    name: "Nav",
    data() {
        return {
            searchQuery: null,
        };
    },
    methods: {
        onItemChanged(event, currentItem, lastActiveItem) {
            currentItem.classList.toggle("active");
            if (lastActiveItem != null) {
                lastActiveItem.classList.toggle("active");
            }
        },
        scrollUp() {
            const home = document.querySelector(".home-page");
            home.classList.toggle("active");
        },
        search() {
            window.find(this.searchQuery);
            return true;
        },
    },
    mounted() {
        window.addEventListener("scroll", function () {
            let header = document.querySelector(".navbar");
            let windowPosition = window.scrollY > 0;
            header.classList.toggle("scrolling-active", windowPosition);

            // var winScroll =
            //     document.body.scrollTop || document.documentElement.scrollTop;
            // var height =
            //     document.documentElement.scrollHeight -
            //     document.documentElement.clientHeight;
            // var scrolled = (winScroll / height) * 100;
            // document.getElementById("myBar").style.width = scrolled + "%";
        });
    },
};
</script>

<style scoped>
/* .is-active {
    color: #fff !important;
} */

.scrolling-active {
    box-shadow: 0 3px 1rem rgba(0, 0, 0, 0.75);
}

.link span {
    margin-left: 5px;
    position: relative;
}
/* .nav-link span:hover {
   
} */

.link span::before {
    content: "";
    position: absolute;
    width: 100%;
    height: 2px;
    bottom: 0;
    left: 0;
    background-color: #dd3444;
    visibility: hidden;
    transform: scaleX(0);
    transition: all 0.3s ease-in-out 0s;
}

.link span:hover::before {
    visibility: visible;
    transform: scaleX(1);
}

.form-control:focus {
    border-color: #dd3444;
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px #dd3444;
}
</style>